export const DESKTOP_ENTRY_PATH = "/desktop/";
export const DASHBOARD_PATH = "/dashboard/";
export const DESKTOP_SIGN_IN_TRANSITION_DURATION_MS = 1_040;

// The sphere swells to this point of the opening, then eases back to rest.
export const SIGN_IN_SWELL_PEAK = 0.42;
const SIGN_IN_SWELL_AMPLITUDE = 0.24;

/** Resting sphere diameter for the window: the landing's size, shrunk to fit narrow windows. */
export function signInSphereSize(width: number, height: number) {
  return Math.round(Math.max(220, Math.min(width * 0.62, height * 0.42, 400)));
}

/** Speech-style amplitude for the opening swell: a quick rise, then a slow return to rest. */
export function signInSwellAmplitude(progress: number) {
  if (progress <= 0 || progress >= 1) return 0;
  if (progress < SIGN_IN_SWELL_PEAK) {
    const rise = progress / SIGN_IN_SWELL_PEAK;
    return SIGN_IN_SWELL_AMPLITUDE * (1 - (1 - rise) ** 3);
  }
  const fall = (progress - SIGN_IN_SWELL_PEAK) / (1 - SIGN_IN_SWELL_PEAK);
  return SIGN_IN_SWELL_AMPLITUDE * (1 - fall * fall * (3 - 2 * fall));
}

export function shouldUseEmbeddedDesktopAuth({
  isElectron,
  platform,
}: {
  isElectron: boolean;
  platform: string | null;
}): boolean {
  return isElectron && platform === "linux";
}

export type DesktopEntryDestination = "/" | typeof DASHBOARD_PATH | null;

export function resolveDesktopEntryDestination({
  isElectron,
  hasSession,
}: {
  isElectron: boolean;
  hasSession: boolean;
}): DesktopEntryDestination {
  if (!isElectron) return "/";
  return hasSession ? DASHBOARD_PATH : null;
}

/** `?error=` codes the signed-out pages explain (see `signedOutErrorMessage`). */
export type SignedOutError = "session_failed" | "signup_email_not_allowed";

export function signedOutDestination({
  isElectron,
  sessionFailed = false,
  error,
}: {
  isElectron: boolean;
  sessionFailed?: boolean;
  /** A specific reason; wins over `sessionFailed`. */
  error?: SignedOutError;
  loginEntry?: "home" | null;
}): string {
  const basePath = isElectron
    ? DESKTOP_ENTRY_PATH
    : "/";
  const code = error ?? (sessionFailed ? "session_failed" : null);
  return code ? `${basePath}?error=${code}` : basePath;
}
